import { useEffect, useState } from 'react';

// Control: the ctrl-key; Meta: the command-key (macOS)
const multiSelectKeys = ['Control', 'Meta'];

const useMultiSelect = () => {
  const [ctrlDown, setCtrlDown] = useState(false);

  useEffect(() => {
    const setCtrl = (event: KeyboardEvent) => {
      if (event.type === 'keydown' && multiSelectKeys.includes(event.key))
        setCtrlDown(true);
      if (event.type === 'keyup' && multiSelectKeys.includes(event.key))
        setCtrlDown(false);
    };
    window.addEventListener('keydown', setCtrl);
    window.addEventListener('keyup', setCtrl);

    return () => {
      window.removeEventListener('keydown', setCtrl);
      window.removeEventListener('keyup', setCtrl);
    };
  }, []);

  return ctrlDown;
};

export default useMultiSelect;
